import { render, staticRenderFns } from "./DefaultPage.vue?vue&type=template&id=5f3c1950&scoped=true&"
import script from "./DefaultPage.vue?vue&type=script&lang=js&"
export * from "./DefaultPage.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPage.vue?vue&type=style&index=0&id=5f3c1950&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c1950",
  null
  
)

export default component.exports